import { Widget, WidgetLayout } from 'domain/widget';
import type { GlyphName } from '@neptune/shared/core-glyphs-domain';
import { ArrayElementType } from 'common/utility-types';

export type Dashboard = {
  color?: string;
  icon?: GlyphName;
  id: string;
  name: string;
  layouts: DashboardLayouts;
  runIds?: string[];
  type: DashboardType;
  widgets: Widget[];
  autoGenerated?: boolean;
  lastUpdatedTime?: Date;
  createdTime?: Date;
  experimentShortId?: string;
  owner?: string;
  versionBranchId: string;
  versionName?: string;
  versionDescription?: string;
};

export interface NewDashboard {
  color?: string;
  experimentShortId?: string;
  icon?: string;
  layouts: DashboardLayouts;
  name: string;
  runIds?: string[];
  type: DashboardType;
  versionDescription?: string;
  versionName?: string;
  widgets: Widget[];
}

export type NewVersionDashboard = Omit<NewDashboard, 'experimentShortId'> & {
  versionBranchId: string;
};

export const dashboardBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'] as const;

export type DashboardBreakpoint = ArrayElementType<typeof dashboardBreakpoints>;

export type DashboardBreakpointMap<T> = Record<DashboardBreakpoint, T>;

export type DashboardLayouts = DashboardBreakpointMap<WidgetLayout[]>;

export type DashboardType = 'compare' | 'experiment' | 'report';

export function isSingleEntityDashboard(type: DashboardType) {
  return type === 'experiment';
}

export function isMultiEntityDashboard(type: DashboardType) {
  return type === 'compare' || type === 'report';
}
